<template>
    <b-container>
        <b-row>
            <b-col md="12">
                <card>
                    <template #header-content>
                        <font-awesome-icon :icon="['fas', 'check']" />
                        <span class="ml-2">Email Sent</span>
                    </template>
                    <template #body>
                        <b-row>
                            <b-col>
                                Your email has been sent. You may close this
                                window now.
                            </b-col>
                        </b-row>
                    </template>
                </card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import Card from '../../generic/card/card.vue';

export default {
    name: 'OnlineBookingQuoteSent',
    components: { Card },
};
</script>
